/*
  Compatibility layer for pubstack data and AngularJS story service
*/
/* eslint-disable @typescript-eslint/camelcase */
import { getRevisionDiff, getRevision } from '~/api/story'

function makeLegacyRevision(pubstackRevision) {
  return {
    branch: 'default',
    editions: [],
    revision_id: pubstackRevision.id,
    // TODO - when Pubstack API adds this data
    user_id: pubstackRevision.user_id,
    parent_id: pubstackRevision.parent_id,
  }
}

export function getDiffWithLegacyRevision(storyId, revisionId) {
  return Promise.all([
    getRevision(storyId, revisionId),
    getRevisionDiff(storyId, revisionId),
  ]).then(([revisionData, diffData]) => {
    // getRevision returns document, revision, and legacyStory
    return {
      data: {
        ...diffData,
        _id: storyId,
        [`rev${revisionId}`]: {
          _id: storyId,
          ...revisionData.revision.ans,
        },
        revision: makeLegacyRevision(revisionData.revision),
      },
    }
  })
}
